import { render } from "./CloseButtonPage.vue?vue&type=template&id=3a048364&ts=true"
import script from "./CloseButtonPage.vue?vue&type=script&lang=ts"
export * from "./CloseButtonPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__